import React from 'react';
interface PaymentTransaction {
  transaction: string;
  docNo: string;
  date: string;
  paymentMethod: string;
  amount: number;
  balance: number;
}
interface PaxStatementPaymentsProps {
  transactions: PaymentTransaction[];
  currency: string;
}
export function PaxStatementPayments({
  transactions,
  currency
}: PaxStatementPaymentsProps) {
  // Hide section if no transactions
  if (!transactions || transactions.length === 0) {
    return null;
  }
  const formatCurrency = (amount: number) => {
    return `${currency} ${amount.toFixed(2)}`;
  };
  return <div className="mb-6" data-id="element-760">
      <h3 className="text-sm font-bold text-neutral-900 uppercase tracking-wide mb-4 pb-2 border-b-2 border-neutral-300" data-id="element-761">
        Payment Transactions
      </h3>

      <div className="border border-neutral-200 rounded-lg overflow-hidden" data-id="element-762">
        <table className="w-full text-xs" data-id="element-763">
          <thead className="bg-neutral-50 border-b border-neutral-200" data-id="element-764">
            <tr data-id="element-765">
              <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-766">
                Transaction
              </th>
              <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-767">
                Doc No.
              </th>
              <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-768">
                Date
              </th>
              <th className="text-left font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-769">
                Payment Method
              </th>
              <th className="text-right font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-770">
                Amount
              </th>
              <th className="text-right font-semibold text-neutral-700 uppercase tracking-wide px-3 py-2" data-id="element-771">
                Balance
              </th>
            </tr>
          </thead>
          <tbody data-id="element-772">
            {transactions.map((txn, index) => <tr key={index} className="border-b border-neutral-200 last:border-b-0" data-id="element-773">
                <td className="px-3 py-2.5 font-semibold text-neutral-900" data-id="element-774">
                  {txn.transaction}
                </td>
                <td className="px-3 py-2.5 text-neutral-900" data-id="element-775">{txn.docNo}</td>
                <td className="px-3 py-2.5 text-neutral-900" data-id="element-776">{txn.date}</td>
                <td className="px-3 py-2.5 text-neutral-900" data-id="element-777">
                  {txn.paymentMethod}
                </td>
                <td className="px-3 py-2.5 text-right text-green-600 tabular-nums font-semibold" data-id="element-778">
                  {formatCurrency(txn.amount)}
                </td>
                <td className="px-3 py-2.5 text-right text-neutral-900 tabular-nums font-semibold" data-id="element-779">
                  {formatCurrency(txn.balance)}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}